import React from "react";
import { Container, Typography, Box} from "@mui/material";
import styled from "@emotion/styled";
import { motion } from "framer-motion";
import TaskAltIcon from '@mui/icons-material/TaskAlt';

import abmlogo from './images/abmlogo.png';



const HeadingStyle = styled(Box)({
    textAlign: "center",
});

const StylizedContainer = styled(Container)({
    background: "#0177cf"
});

const ContentStyle = styled("div")({
    maxWidth: 450,
    height: "75vh",
    padding: 25,
    margin: "auto",
    display: "flex",    
    justifyContent: "center",
    flexDirection: "column",
});

const LogoStyle = styled("div")({
  maxWidth: 450,
  padding: "10px",
  margin: "auto",
  display: "flex",
  justifyContent: "center",
  flexDirection: "column",
  backgroundRepeat: "no-repeat",  
});

let easing = [0.6, -0.05, 0.01, 0.99];
const fadeInUp = {
  initial: {
    y: 60,
    opacity: 0,
    transition: { duration: 0.6, ease: easing },
  },
  animate: {
    y: 0,
    opacity: 1,
    transition: {
      duration: 0.6,
      ease: easing,
    },
  },
};

const animate = {
  opacity: 1,
  y: 0,
  transition: {
    duration: 0.6,
    ease: easing,
    delay: 0.16,
  },
};

export default function SuccessScreen() {
    return(
        <>
        <StylizedContainer maxWidth="sm">
            <ContentStyle>              
                <HeadingStyle component={motion.div} {...fadeInUp}>   
                    <TaskAltIcon sx={{ fontSize: 200, color: "white" }}/>
                    <Typography 
                        variant="h4" sx={{ color: "text.secondary",  mb: 5 }} 
                        component={motion.div}
                        initial={{ opacity: 0, y: 40 }}
                        animate={animate}
                    >
                        <b>Success</b>
                    </Typography>
                </HeadingStyle>          
            </ContentStyle>
        </StylizedContainer>
        <LogoStyle>
              <img alt="" src={abmlogo} width={150} height={70} />
        </LogoStyle>
        </>
    );
}